import { AuthService } from './../../services/auth.service';
import { AuthenticationService } from "../../services/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import { OnInit, Component, ViewChild, ElementRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, NG_VALIDATORS, Validators, Validator, NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { logbaseService } from '../../services/logbase.service';
import { CustomValidators } from './../../directives/custom-validator.directive';
import { DatePipe } from '@angular/common'
//import { JwtHelper } from "angular2-jwt";
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { swal } from '@sweetalert2/ngx-sweetalert2';
import swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from '../../services/utils';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [DatePipe]
})

export class LoginComponent implements OnInit {
  token: any;
  loginDetails: any;
  maintainenceMessage: any;
  maintainceList: any;
  model: any = {};
  selectedValue: string;
  returnUrl: string;
  resetreturnUrl: string;
  //jwt = new JwtHelper();
  attempt: any;
  loginAttempt: any;
  attemptRes: any;
  modalRef: NgbModalRef;


  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  extendSession = false;
  loggedIn: any;
  idleStart = false;

  constructor(private router: Router, private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService,
    private logbaseService: logbaseService,
    public datepipe: DatePipe,
    private idle: Idle, private keepalive: Keepalive,
    private modalService: NgbModal, private authService : AuthService,
    private spinner: NgxSpinnerService

  ) {

    /*this.translate.get("LogBase will be unavailable in the above stated time frame. We apologize for the inconvenience.").subscribe((res: string) => {
      ""
    });*/

   


  };

  verifyLogin() {

    //let tokenKeyFromUrl="eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJ5Z3o1VG9saXdVWVhyOTZUR2dHdC1WYVE0VmI4el8zQnRRanh1bWpkS0RVIn0.eyJqdGkiOiJhMzFkYWI1Yy0zOTQ3LTQwMTMtOWMwOC0zZjk0MjdiNGRiOGIiLCJleHAiOjE1OTA1NTcwMDcsIm5iZiI6MCwiaWF0IjoxNTkwNDcyMTMyLCJpc3MiOiJodHRwczovL2RmbC1pZG0uZm9mLWZ1c28uY29tL2F1dGgvcmVhbG1zL3N0Zy1kZmwiLCJhdWQiOlsicmVhbG0tbWFuYWdlbWVudCIsImJyb2tlciIsImFjY291bnQiXSwic3ViIjoiMWQ3NGMwYzUtMDhmMC00YzRlLTkxNTctNWEzNzFjMjZmOGE4IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiM2ExYjFiMDUiLCJub25jZSI6InljMm1oa3BicHo4IiwiYXV0aF90aW1lIjoxNTkwNDcwNjA3LCJzZXNzaW9uX3N0YXRlIjoiYWMxZTVlZjktMDZlMy00YThjLThiYTEtNmEzNzBiM2VhYmRmIiwiYWNyIjoiMCIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwczovL2QtcmVkaXJlY3QuZm9mLWZ1c28uY29tL2NhbGxiYWNrL2xvZ2Jhc2UiXSwicmVhbG1fYWNjZXNzIjp7InJvbGVzIjpbInVtYV9hdXRob3JpemF0aW9uIiwibGJfc3VwcGxpZXIiXX0sInJlc291cmNlX2FjY2VzcyI6eyJyZWFsbS1tYW5hZ2VtZW50Ijp7InJvbGVzIjpbInZpZXctaWRlbnRpdHktcHJvdmlkZXJzIiwidmlldy1yZWFsbSIsIm1hbmFnZS1pZGVudGl0eS1wcm92aWRlcnMiLCJpbXBlcnNvbmF0aW9uIiwicmVhbG0tYWRtaW4iLCJjcmVhdGUtY2xpZW50IiwibWFuYWdlLXVzZXJzIiwicXVlcnktcmVhbG1zIiwidmlldy1hdXRob3JpemF0aW9uIiwicXVlcnktY2xpZW50cyIsInF1ZXJ5LXVzZXJzIiwibWFuYWdlLWV2ZW50cyIsIm1hbmFnZS1yZWFsbSIsInZpZXctZXZlbnRzIiwidmlldy11c2VycyIsInZpZXctY2xpZW50cyIsIm1hbmFnZS1hdXRob3JpemF0aW9uIiwibWFuYWdlLWNsaWVudHMiLCJxdWVyeS1ncm91cHMiXX0sImJyb2tlciI6eyJyb2xlcyI6WyJyZWFkLXRva2VuIl19LCJhY2NvdW50Ijp7InJvbGVzIjpbIm1hbmFnZS1hY2NvdW50IiwibWFuYWdlLWFjY291bnQtbGlua3MiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6Im9wZW5pZCBlbWFpbCBwcm9maWxlIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJuYW1lIjoiYXJ1biByIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiYXJ1bnIxMSIsImdpdmVuX25hbWUiOiJhcnVuIiwiZmFtaWx5X25hbWUiOiJyIiwiZW1haWwiOiJjYXBnZW1pbmkucmMuckBkYWltbGVyLmNvbSJ9.LTvhozQKUfoCNTxnPsUruq8GdxjOGXm-GrRdl42uKv9Mk1A2unBbTDZd79p3hZkKhFqhLr0hCQDw8rMcthsFHr4keWCOjQwCoGYyv_X57fK9FqU25TM78_hM3HyoR-TX6Vf3NFNbPbh06wNToNW3Vvpvrhis2Duvoz8QI1qr-hKPTNzjFK-SvxC8PqiKCOmH3v_WoB-3fnug8cRHLc4GPISEzLCKDhxmB6euFpOLg9TQEVoY_gwkupuJMacs_fmaBEaSBUee1D3dSaQWg5F43URTcSCk6E6OLXoNpFhBkggqiiJ8XxlCrtW9L3SAX-_vxGUd9ZEFYka37w1Cbs8cmA";
    
    let tokenKey1FromUrl;
    let tokenKey2FromUrl;
    let tokenKey3FromUrl;
    this.route.queryParams.subscribe(params => {
     // tokenKey1FromUrl = params["access_token"];
      tokenKey2FromUrl = params["id_token"];
      tokenKey3FromUrl = params["refresh_token"];   //Get the token from Query params
    });

    //alert("token extracted from url is "+tokenKeyFromUrl);

    if ( tokenKey2FromUrl &&
      tokenKey2FromUrl.length > 0 &&
      tokenKey2FromUrl != "null") {
        this.authService.loginFromToken(tokenKey2FromUrl,tokenKey3FromUrl);
    } // Key present 
    else {
      if (this.authService.isAuthenticated()) {
       //this.spinner.hide();
       this.router.navigate(["/dashboard"])
      }
      else {
       this.authService.redirectToDaimler("login");
      }
    }
  }

  



  

  ngOnInit() {
    //alert("LoginComponent");  

    // Utils.alertWithMesssgeUpdatedForDaimlerID();
    //  setTimeout(() => { this.spinner.show(),this.verifyLogin()}, 4000);
     
    //  setTimeout(() => {this.spinner.hide();}, 8000);
    this.verifyLogin();
   //setTimeout(() => { this.spinner.show()}, 5000);
    

   //this.spinner.show();

   //setTimeout(() => { this.spinner.show(), this.verifyLogin()}, 8000);
   

   //this.spinner.hide();


  /*  this.logbaseService.getMaintainenceHistory()
      .subscribe(result => {
        this.maintainceList = result.response;
        this.maintainenceMessage = this.maintainceList[this.maintainceList.length - 1];
        let downDate = this.maintainenceMessage["fromDownDate"];
        let fromDownTime = this.maintainenceMessage["fromDownTime"];
        let toDownDate = this.maintainenceMessage["toDownDate"];
        let toDownTime = this.maintainenceMessage["toDownTime"];

        var dtimeSt = fromDownTime.split(":");
        var utimeSt = toDownTime.split(":");
        let message = this.maintainenceMessage["message"];
        var x = new Date();
        function formatTime(hours) {
          var d = new Date(hours),
            hour = '' + (d.getHours()),
            min = '' + (d.getMinutes()),
            sec = '' + (d.getSeconds());
          if (hour.length < 2) hour = '0' + hour;
          if (min.length < 2) min = '0' + min;
          if (sec.length < 2) sec = '0' + min;
          return [hour, min, sec].join(':');
        }
        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = '0' + month;
          if (day.length < 2) day = '0' + day;
          return [year, month, day].join('-');
        }
        var newDate = formatDate(x);
        var newTime = formatTime(x)
        var initialValue = newDate + " " + newTime
        var endValue = toDownDate + " " + toDownTime
        var dt1 = new Date(initialValue);
        var dt2 = new Date(endValue);
        function diff_minutes(dt2, dt1) {
          var diff = (dt2.getTime() - dt1.getTime()) / 1000;
          diff /= 60;
          return Math.abs(Math.round(diff));
        }
        if (dt2.getTime() > dt1.getTime()) {


          var timeouttally = diff_minutes(dt1, dt2) * 60000;
          this.toastr.info(
            this.translate.instant("Date, Time / 日程: " + this.datepipe.transform(downDate, 'yyyy-MM-dd') + " " + dtimeSt[0] + ":" + dtimeSt[1] + " to " + this.datepipe.transform(toDownDate, 'yyyy-MM-dd') + " " + utimeSt[0] + ":" + utimeSt[1] + "<br/>LogBase will be unavailable in the above stated time frame. We apologize for the inconvenience.<br/>上記の時間帯に、メンテナンスのため、LogBaseをご利用頂くことができません。ご迷惑をおかけしますが、ご理解とご協力を宜しくお願いいたします。<br/>" + message), this.translate.instant("Planned Maintainence / メンテナンス"), {
              timeOut: timeouttally,
              extendedTimeOut: 0,
              enableHtml: true
            });

        }
        else {
          this.toastr.clear;
        }

      });


    // API to fix pre-flight issue
    this.preflightFix();

    //this.data.setUser(this.username);
    this.createFormControls();
    // reset login status

    this.returnUrl = '/dashboard';
    this.resetreturnUrl = '/resetPassword'
    this.selectedValue = localStorage.getItem('language')
    if (this.selectedValue == null || this.selectedValue == undefined) {
      this.selectedValue = 'en'
    }*/
  }

  

}

